<div class="progress-cards-wrap position-relative" #modulescontainer>    
  <div class="loader position-fixed left-0 right-0" *ngIf="!initialloaddone"></div>
  <div *ngFor="let module of this.modules" #modulecontainer class="modulecontainer">
    <app-module #module [module]="module" [inPackage]="inPackage" [currentUserIsAdmin]="currentUserIsAdmin" (deleteClicked)="deleteClickedFired($event)" #moduleComponent></app-module>
  </div>
</div>
<p *ngIf="this.modules.length === 0 && !currentUserIsAdmin">Courses coming soon</p>
<p *ngIf="initialloaddone && this.isUserModulesControl && (!this.modules || this.modules.length === 0 )" class="font-italic mb-0">You Are Not Enrolled For Any Courses</p>